export default {
	activeCallEnded({data}) {
		this.unshift("clients", "group.calls", data, data.callable.id);
	},
	toDoAdded({data}) {
		this.unshift("clients", "group.todos", data, data.relations[0].id);
	},
	noteAdded({data}) {
		this.unshift("clients", "group.notes", data, data.notable.id);
	},
	quoteUpdated({data}) {
		this.store.dispatch("quotes/updateModel", data);
	},
	sessionReferralUpdated({data}) {
		this.store.commit("authStore/SET", {
			key: "session.introduction",
			data: data.introduction,
		});
	},
};
